import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useTopCommentsQuery = createQueryHook(MembershipsCreatorApiClient.getTopComments, {
  queryKey: ['topComments'],
})
